import React from 'react'
import { Box, Table, Text } from '@workwhile/ui'
import { ColumnDef } from '@tanstack/react-table'
import { formatInTimeZone } from 'date-fns-tz'
import { useTimeClocksContextValue } from '../context/TimeClocksProvider'
import { TimeClock } from '../types'
import { ActionsCell } from './ActionsCell'

const DISPLAY_TZ = 'America/Los_Angeles'

const formatDateTime = (value: string) =>
  formatInTimeZone(value, DISPLAY_TZ, 'MMM d, yyyy h:mm a z')

export const TimeClocksTable = () => {
  const {
    state: { items, locations, isPending },
  } = useTimeClocksContextValue()

  const columns: ColumnDef<TimeClock>[] = [
    {
      header: 'Vendor clock id',
      accessorKey: 'vendorClockId',
      cell: ({ row }) => <Text>{row.original.vendorClockId}</Text>,
    },
    {
      header: 'Location',
      accessorKey: 'locationId',
      cell: ({ row }) => {
        const location = locations?.find(
          (candidate) => Number(candidate.id) === row.original.locationId
        )
        return <Text>{location?.name ?? String(row.original.locationId)}</Text>
      },
    },
    {
      header: 'Manufacturer',
      accessorKey: 'manufacturer',
      cell: ({ row }) => <Text>{row.original.manufacturer}</Text>,
    },
    {
      header: 'Model',
      accessorKey: 'model',
      cell: ({ row }) => <Text>{row.original.model}</Text>,
    },
    {
      header: 'Created',
      accessorKey: 'createdAt',
      cell: ({ row }) => (
        <Text style={{ whiteSpace: 'nowrap' }}>
          {formatDateTime(row.original.createdAt)}
        </Text>
      ),
    },
    {
      header: 'Actions',
      cell: ({ row }) => <ActionsCell timeClock={row.original} />,
    },
  ]

  if (isPending) {
    return null
  }

  if (items.length === 0) {
    return (
      <Box>
        <Text color="lightText">No time clocks found.</Text>
      </Box>
    )
  }

  return (
    <Box overflowX="auto">
      <Table columns={columns} data={items} textVerticalAlign="top" />
    </Box>
  )
}
